import React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import { useLanguage } from '../utils/LanguageContext';
import '../styles/introduction.css';

const Introduction: React.FC = () => {
    const { t } = useLanguage();
    
    const features = [
        {
            title: t('features.photos.title'),
            description: t('features.photos.description')
        },
        {
            title: t('features.wishes.title'),
            description: t('features.wishes.description')
        },
        {
            title: t('features.location.title'),
            description: t('features.location.description')
        },
        {
            title: t('features.guestlist.title'),
            description: t('features.guestlist.description')
        }
    ];

    return (
        <section id="introduction" className="introduction-content">
            <h1>{t('intro.title')}</h1>
            <p>{t('intro.subtitle')}</p>
            <p>{t('intro.description')}</p>
            <p>{t('intro.details')}</p>
            
            <div className="mt-6">
                <h2 className="text-xl font-bold mb-4">{t('intro.whatCanYouDo')}</h2>
                <div className="space-y-2">
                    {features.map((feature, index) => (
                        <Disclosure key={index}>
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white/10 px-4 py-2 text-left text-sm font-medium hover:bg-white/20">
                                        <span>{feature.title}</span>
                                        <span className={`transform ${open ? 'rotate-180' : ''} transition-transform`}>
                                            ▼
                                        </span>
                                    </Disclosure.Button>
                                    <Transition
                                        enter="transition duration-100 ease-out"
                                        enterFrom="transform scale-95 opacity-0"
                                        enterTo="transform scale-100 opacity-100"
                                        leave="transition duration-75 ease-out"
                                        leaveFrom="transform scale-100 opacity-100"
                                        leaveTo="transform scale-95 opacity-0"
                                    >
                                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm">
                                            {feature.description}
                                        </Disclosure.Panel>
                                    </Transition>
                                </>
                            )}
                        </Disclosure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Introduction;